"use client"

import { useHighZBottomSheetStore } from "./store/useHighZBottomSheetStore"
import BaseBottomSheetPortal from "./BaseBottomSheetPortal"

export default function HighZBottomSheetPortal() {
  const store = useHighZBottomSheetStore()

  return <BaseBottomSheetPortal store={store} zIndex="z-10001" />
}
